// @ts-nocheck
// Vuex module の段階的 TypeScript 化（まずはファイル移管。詳細な型は後続対応）
import { getBeforeDate, getDateStr } from '@/js/utils/date'

const state = {
  // HH:mm:ssを00:00:00で揃える為
  date: {
    startDate: getBeforeDate(getDateStr(new Date(), 'YYYY-MM-DD'), 31),
    endDate: getBeforeDate(getDateStr(new Date(), 'YYYY-MM-DD'), 1),
    isOneDay: '0',
  },
}

const mutations = {
  setStartDate(state, startDate) {
    state.date.startDate = startDate
  },
  setEndDate(state, endDate) {
    state.date.endDate = endDate
  },
  setIsOneDay(state, isOneDay) {
    state.date.isOneDay = isOneDay
  },
}

const getters = {
  startDate(state) {
    return state.date.startDate
  },
  endDate(state) {
    return state.date.endDate
  },
  isOneDay(state) {
    return state.date.isOneDay
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
